export default __webpack_public_path__ + "static/media/GVL_logo_icon.48514189.png";